import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Details = {
    MAIN: (
        <FormattedMessage
            id='details.main'
            defaultMessage='Main'
        />
    ),
    LINKED: (
        <FormattedMessage
            id='details.linked'
            defaultMessage='Linked'
        />
    ),
    REPORTING: (
        <FormattedMessage
            id='details.reporting'
            defaultMessage='Reporting'
        />
    ),
    STATISTICS: (
        <FormattedMessage
            id='details.statistics'
            defaultMessage='Statistics'
        />
    ),
    DEBUG: (
        <FormattedMessage
            id='details.debug'
            defaultMessage='Debug'
        />
    ),
    TRANSLATIONS: (
        <FormattedMessage
            id='details.translations'
            defaultMessage='Translations'
        />
    ),
    DETAILS: (
        <FormattedMessage
            id='details.details'
            defaultMessage='Details'
        />
    ),
    DETAILS_OF: detailsOf,
    MANAGE: manage,
    GENERAL: (
        <FormattedMessage
            id='details.general'
            defaultMessage='General'
        />
    ),
    EVENT_LOGS: (
        <FormattedMessage
            id='details.eventLogs'
            defaultMessage='Event logs'
        />
    ),
    EVENTS: (
        <FormattedMessage
            id='details.events'
            description='Tab label for the full event log on entity detail modals'
            defaultMessage='Events'
        />
    ),
    HISTORY: (
        <FormattedMessage
            id='details.history'
            description='Tab label for the history timeline on entity detail modals'
            defaultMessage='History'
        />
    ),
    SHOW_CHILDREN: (
        <FormattedMessage
            id='details.showChildren'
            description='Toggle label to include child entity events in the transaction or colli event history'
            defaultMessage='Show children'
        />
    ),
    VIEW_DETAILS: (
        <FormattedMessage
            id='details.viewDetails'
            defaultMessage='View details'
        />
    )
};

function detailsOf(item: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='details.details_of'
            description='Details of item message (eg.: Transaction details)'
            defaultMessage='{item} details'
            values={{
                item
            }}
        />
    );
}

function manage(item: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='details.manage'
            description='Manage entity'
            defaultMessage='Manage {item}'
            values={{
                item
            }}
        />
    );
}
